import { makeStyles } from '@material-ui/core';
import React from 'react';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";

const useStyles = makeStyles(() => ({
  carousel: {
    width: '100%',
  },
  carouselItem: {
    width: '100%',
  },
}));

const carouselItems = [
  {
    original: '/screenshots/flashyplayer.png',
    thumbnail: '/screenshots/flashyplayer.png',
  },
  {
    original: '/screenshots/settings.png',
    thumbnail: '/screenshots/settings.png',
  },
];

export const ScreenshotPage = (): JSX.Element => {
  const classes = useStyles();
  return (
    <div className={classes.carousel}>
      <ImageGallery items={carouselItems} />
    </div>
  );
};
